/**
 * Tên miền công khai của SAPA (web quầy + trang pháp lý + API) — MỘT chỗ duy nhất (ADR-114).
 * Chữ hiển thị dùng `TEN_MIEN_SAPA`; liên kết / mã QR dùng `TRANG_CHU_SAPA`. Đổi tên miền: sửa đúng dòng này.
 * Chỗ cố ý KHÔNG gom (cấu hình hạ tầng Caddy / compose / shell, địa chỉ API dự phòng của Mini App, chú thích) ghi ở
 * docs/plans/san-pham-mien-phi-qr-ntfy.md mục D.3. Không nhập gì, không `node:*` — chạy được cả trong trình duyệt.
 */
export const TEN_MIEN_SAPA = 'sapa.autopostvn.com' as const
export const TRANG_CHU_SAPA = `https://${TEN_MIEN_SAPA}` as const
